import { parseIntM } from '@execonline-inc/numbers';
import { observer } from 'mobx-react';
import * as React from 'react';
import LearningCollectionsStore from '../../Store';
import PublishingReactions from './CurrentCollectionStep/Share/PublishSection/Store/Reactions';
import LearningDesignsReactions from '../LearningDesigns/Reactions';
import ProductLicensesReactions from '../ProductLicenses/Reactions';
import withRouter from '../WithRouter';
import CurrentCollectionStep from './CurrentCollectionStep';
import LearningCollectionEditStore from './Store';
import LearningCollectionEditReactions from './Store/Reactions';
import { LearningCollectionEditableStep } from './Store/Types';

interface Props {
  params: { id: string; step: LearningCollectionEditableStep };
  store: LearningCollectionsStore;
}

class Edit extends React.Component<Props, {}> {
  learningCollectionEditStore: LearningCollectionEditStore;

  constructor(props: Props) {
    super(props);
    this.learningCollectionEditStore = new LearningCollectionEditStore(props.store);
  }

  componentDidMount() {
    const { id, step } = this.props.params;
    this.learningCollectionEditStore.loading(id, step);
    this.learningCollectionEditStore.productLicensesStore.loading();
  }

  render() {
    return (
      <>
        <CurrentCollectionStep store={this.learningCollectionEditStore} />
        <LearningCollectionEditReactions store={this.learningCollectionEditStore} />
        <PublishingReactions store={this.learningCollectionEditStore.publishingStore} />
        <LearningDesignsReactions store={this.learningCollectionEditStore.learningDesignsStore} />
        <ProductLicensesReactions
          store={this.learningCollectionEditStore.productLicensesStore}
          learningCollectionId={parseIntM(this.props.params.id)}
        />
      </>
    );
  }
}

export default observer(withRouter(Edit));
